import {
  PinInputDescendantsProvider,
  PinInputProvider,
  usePinInput,
  usePinInputField,
} from "@chakra-ui/pin-input";
import React from "react";
import styled from "@emotion/styled";

const StyledPinInput = styled.input`
  width: 54px;
  height: 60px;
  text-align: center;
  color: #616578;
  border-radius: 8px;
  font-family: "Roobert";
  font-size: 24px;
  font-weight: 400;
  line-height: 30px;
  padding: 0;
  border: 1.5px solid #616578;
  margin: 0 9px;
`;

function Input(props: any) {
  const inputProps = usePinInputField(props);
  return <StyledPinInput {...inputProps} />;
}

type OTPInputProps = {
  id?: string;
  autoFocus: boolean;
  onComplete: (value: string) => void;
  length: number;
};

const ARIA_LABEL = "Please enter your OTP code";

const OTPInput = ({
  id = "otp-input",
  autoFocus,
  onComplete,
  length = 6,
}: OTPInputProps) => {
  const { descendants, ...context } = usePinInput({
    type: "number",
    placeholder: "",
    otp: true,
    id,
    autoFocus,
    onComplete,
  });
  return (
    <PinInputDescendantsProvider value={descendants}>
      <PinInputProvider value={context}>
        {Array.from({ length }, (_v, i) => (
          <Input key={i} aria-label={ARIA_LABEL} data-testid={`${id}-${i}`} />
        ))}
      </PinInputProvider>
    </PinInputDescendantsProvider>
  );
};

export { OTPInput };
